import { pushDatalayer } from '../utilities/datalayer';

const dataNavigationElements = Array.from(document.querySelectorAll('[data-navigation'));

if (dataNavigationElements) {
    dataNavigationElements.map((navigationElement) => {
        navigationElement.addEventListener("click", () => {
            const navigationParent = navigationElement.dataset.navigationParent;

            pushDatalayer({
                event : "menu_click",
                navigation_type: navigationElement.dataset.navigation,
                navigation_level: navigationElement.dataset.navigationLevel,
                navigation_1: navigationParent ? navigationParent : navigationElement.dataset.navigationLabel,
                navigation_2: navigationParent ? navigationElement.dataset.navigationLabel : ''
            })
        });
    })
}
